import { http } from "../http";

export interface CustomerRate {
    RATE1LEFTSUM: string;
    RATE1LEFTCUR: string;
    RATE1RIGHTSUM: string;
    RATE1RIGHTCUR: string;
    RATE2LEFTSUM: string;
    RATE2LEFTCUR: string;
    RATE2RIGHTSUM: string;
    RATE2RIGHTCUR: string;
    AMOUNT: string;
    MSGSTAT: string;
};

export interface SendData {
    CIF: string;
    CUR1: string;
    AMOUNT1: string;
    CUR2: string;
    AMOUNT2: string;
}


export const calcRate = async (transfer: SendData): Promise<CustomerRate> => {
    const { data } = await http.post<CustomerRate>("exchange/exchange/getcustomerrates", transfer);
    return data;
};

